import { render, staticRenderFns } from "./DistributorTranslations.vue?vue&type=template&id=150a16c3"
import script from "./DistributorTranslations.vue?vue&type=script&lang=js"
export * from "./DistributorTranslations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports